"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var headerParam = function headerParam() {
  return {
    user: localStorage.getItem('userName')
  };
};
// 权限设置
var domain_p = process.env.VUE_APP_BASE_API_LOGIN;
var SystemService = /*#__PURE__*/function (_Service) {
  function SystemService() {
    (0, _classCallCheck2.default)(this, SystemService);
    return _callSuper(this, SystemService, arguments);
  }
  (0, _inherits2.default)(SystemService, _Service);
  return (0, _createClass2.default)(SystemService, [{
    key: "menuList",
    value:
    // 菜单列表
    function menuList(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get(domain_p + "/vwk/get_column?".concat(_qs.default.stringify(param)));
    }
    // 保存角色菜单权限
  }, {
    key: "saveRole",
    value: function saveRole(data) {
      data.pid = process.env.VUE_APP_PID;
      return this.http.post(domain_p + '/vwk/menu_save', data);
    }

    // 登录时候后端返回角色菜单
    // loginRoles(param) {
    //   param.pid = process.env.VUE_APP_PID
    //   return this.http.get(domain_p + `/vwk/login_column?${qs.stringify(param)}`)
    // }
    // 登录时候后端返回角色菜单
  }, {
    key: "loginRoles",
    value: function loginRoles(param) {
      return this.http.get(domain_p + "/vwk/login_column_tree?".concat(_qs.default.stringify(param)), {
        headers: _objectSpread({}, headerParam())
      });
    }
    /* 角色管理 ===============================*/
    // 添加
  }, {
    key: "addRoles",
    value: function addRoles(data) {
      data.pid = process.env.VUE_APP_PID;
      return this.http.post(domain_p + '/v2/group/add', data);
    }
    // 列表
  }, {
    key: "roleList",
    value: function roleList(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get(domain_p + '/v2/groups', {
        params: param
      });
    }
    // 修改
  }, {
    key: "editRoles",
    value: function editRoles(id, data) {
      data.pid = process.env.VUE_APP_PID;
      return this.http.post(domain_p + '/v2/group/edit/' + id, data);
    }
    // 查询站点角色
  }, {
    key: "lookRoleList",
    value: function lookRoleList(param) {
      return this.http.get('/api/v4/site/roleSiteList', {
        params: param
      });
    }
    // 角色站点编辑
  }, {
    key: "editStandRoles",
    value: function editStandRoles(id, data) {
      return this.http.post('/api/v4/site/roleSiteEdit/' + id, data);
    }

    //   //分类列表
    //   classify(param) {
    //     return this.http.get(domain_p + `/api/access/type_list?${qs.stringify(param)}`)
    //   }
    //   //编辑
    //   compile(id, param) {
    //     return this.http.put(domain_p +'/api/qx/'+id, param)
    //   }
    //   // 启用,禁用
    //   forbid(id) {
    //     return this.http.put(domain_p +'/api/access/edit_state/'+id)
    //   }

    //   //详情
    //   details(id) {
    //     return this.http.get(domain_p +'/api/qx/'+id)
    //   }
  }]);
}(_serviceBase.default);
var _default = exports.default = new SystemService();